@if (showEmailForm) {
    <div id="contact-options">
        <pt-email-option
            [contactData]="emailScreenContactData"
            [enableDragAndDrop]="initData.enableDragAndDrop"
            [isNewDobEnabled]="initData.isNewDobEnabled"
            (disableEmailScreen)="disableEmailScreen($event)"></pt-email-option>
    </div>
}
@if (!showEmailForm) {
    @if (phase3) {
        <pt-focus-contact-page [content]="content" [faqLink]="faqLink" [initData]="initData" [twitterLink]="twitterLink"> </pt-focus-contact-page>
    }
    @if (!initData.enableHelpAndContactPhase2 && !phase3) {
        <div>
            @if (initData.enableHelpAndContactPage) {
                <div>
                    @if (!showEmail) {
                        <div>
                            <lh-header-bar
                                class="d-flex d-sm-none"
                                [content]="content.messages!.HeaderTitle"
                                [showBackButton]="redirectedFromSASWFlow ? false : true"
                                (onBack)="gotoLastKnownProduct(screenName, 'Back')"
                                (onClose)="gotoLastKnownProduct(screenName, 'Close')"></lh-header-bar>
                            <ng-container *ngTemplateOutlet="contactTemplate"></ng-container>
                        </div>
                    }
                    @if (showEmail) {
                        <div>
                            @if (helpAndContactData.showEmailScreen) {
                                <div id="contact-options">
                                    <pt-email-option
                                        [contactData]="emailScreenContactData"
                                        [enableDragAndDrop]="initData.enableDragAndDrop"
                                        (disableEmailScreen)="disableEmailScreen($event)"></pt-email-option>
                                </div>
                            }
                        </div>
                    }
                    @if (showchathistory && !optionsScreen) {
                        <div class="portal-center-wrapper content-width chatcard my-5" id="chathistory" (click)="goToHistory()">
                            <div class="chathistorycard">
                                <div class="cursorPointer d-flex align-vertically">
                                    <div class="{{ initData.chatHistoryContent.messages.class }} chatoption mr-3 ml-4"></div>
                                    <div class="chatbonuscard option-font align-left m-2">
                                        <div class="align-text-in-mobile m-2">
                                            <div class="heading">{{ initData.chatHistoryContent.title }}</div>
                                            <div class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0">
                                                <p>{{ initData.chatHistoryContent.messages.ChatHistory }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            } @else {
                <lh-navigation-layout-page
                    sourceItem="contact"
                    [hideBackButton]="false"
                    [topMenuVisibility]="newAccountMenuService.hideTopMenu('contact')">
                    <ng-container *ngTemplateOutlet="contactTemplate"></ng-container>
                </lh-navigation-layout-page>
            }
        </div>
    }
    <ng-template #contactTemplate>
        @if (!initData.enableHelpAndContactPage) {
            <div>
                <vn-message-panel></vn-message-panel>
                <form #contactForm="ngForm" action autocomplete="off" class="form-base" name="contactForm" novalidate>
                    <div class="portal-page form-base floating-form" id="contactPageContainer" [hidden]="!contactPageVisible">
                        <div [ngClass]="{ 'has-faq': faqItems, 'simple-top-padding': !faqItems }">
                            <!--For premium.com (anonymous non-logged-in user) category area is hidden-->
                            <div class="layout-column">
                                <!--Category Area -->
                                @if (renderCategories) {
                                    <fieldset>
                                        <legend class="text-highlight font-weight-medium">
                                            {{ content.messages!.CategorySection }}
                                        </legend>
                                        <section>
                                            <!--Category -->
                                            <div class="form-element">
                                                <lh-form-field [elementClass]="'form-group-label-i-l'">
                                                    <select
                                                        id="category"
                                                        name="category"
                                                        required
                                                        (ngModelChange)="category_selected()"
                                                        [(ngModel)]="selectedCategory">
                                                        <option class="hide" disabled selected [value]="null">
                                                            {{ content.messages!.CategoryText }}
                                                        </option>
                                                        @for (cl of categoriesList; track cl.category.title) {
                                                            <option [ngValue]="cl.category">
                                                                {{ cl.category.title }}
                                                            </option>
                                                        }
                                                    </select>
                                                </lh-form-field>
                                            </div>
                                            <!--Sub-Category -->
                                            @if (
                                                !(
                                                    !selectedCategory ||
                                                    !selectedCategory.children ||
                                                    disableSubCategory ||
                                                    (selectedCategory.children | objectLength) == 0
                                                )
                                            ) {
                                                <div class="form-element">
                                                    <lh-form-field [elementClass]="'form-group-label-i-l'">
                                                        <select
                                                            id="subcategory"
                                                            name="subcategory"
                                                            required
                                                            (ngModelChange)="updateFaqItems()"
                                                            [(ngModel)]="subCategory">
                                                            <option class="hide" disabled selected [value]="null">
                                                                {{ content.messages!.SubCategoryText }}
                                                            </option>
                                                            @for (sc of subCategories; track sc.title) {
                                                                <option [ngValue]="sc">{{ sc.title }}</option>
                                                            }
                                                        </select>
                                                    </lh-form-field>
                                                </div>
                                            }
                                        </section>
                                    </fieldset>
                                }
                                <!--Send Message Area -->
                                <fieldset [hidden]="faqItems">
                                    <legend class="text-highlight font-weight-medium">
                                        {{ content.messages!.MessageSection }}
                                    </legend>
                                    <section>
                                        <!--Firstname -->
                                        @if (isShown) {
                                            <div class="form-element">
                                                <lh-form-field [labelText]="content.form.firstname.label">
                                                    <input
                                                        #firstname
                                                        maxlength="{{ validation.rules.firstname.maxLength }}"
                                                        minlength="{{ validation.rules.firstname.minLength }}"
                                                        name="firstname"
                                                        required
                                                        type="text"
                                                        [disabled]="wait"
                                                        [(ngModel)]="data.firstName" />
                                                </lh-form-field>
                                                <lh-validation-messages
                                                    [formElement]="contactForm.form.get('firstname')"
                                                    [formElementRef]="firstname"
                                                    [messages]="content.form['firstname']?.validation"></lh-validation-messages>
                                            </div>
                                        }
                                        <!--Surname -->
                                        @if (isShown) {
                                            <div class="form-element">
                                                <lh-form-field [labelText]="content.form.lastname.label">
                                                    <input
                                                        #lastname
                                                        maxlength="{{ validation.rules.lastname.maxLength }}"
                                                        minlength="{{ validation.rules.lastname.minLength }}"
                                                        name="lastname"
                                                        required
                                                        type="text"
                                                        [disabled]="wait"
                                                        [(ngModel)]="data.surname" />
                                                </lh-form-field>
                                                <lh-validation-messages
                                                    [formElement]="contactForm.form.get('lastname')"
                                                    [formElementRef]="lastname"
                                                    [messages]="content.form['lastname']?.validation"></lh-validation-messages>
                                            </div>
                                        }
                                        <!--Email-address -->
                                        <div class="form-element">
                                            <lh-form-field [labelText]="content.form.emailaddress.label">
                                                <input
                                                    #emailaddress
                                                    maxlength="{{ validation.rules.emailAddress.maxLength }}"
                                                    minlength="{{ validation.rules.emailAddress.minLength }}"
                                                    name="emailaddress"
                                                    pattern="{{ validation.rules.emailAddress.regex }}"
                                                    required
                                                    type="email"
                                                    [disabled]="wait"
                                                    [(ngModel)]="data.email" />
                                            </lh-form-field>
                                            <lh-validation-messages
                                                [formElement]="contactForm.form.get('emailaddress')"
                                                [formElementRef]="emailaddress"
                                                [messages]="content.form['emailaddress']?.validation"></lh-validation-messages>
                                        </div>
                                        <!--Device-Type  -->
                                        @if (isShown) {
                                            <div class="form-element d-none d-md-flex">
                                                <lh-form-field [labelText]="content.form.devicetype.label">
                                                    <input
                                                        #deviceType
                                                        maxlength="50"
                                                        name="devicetype"
                                                        placeholder="{{ content.form.devicetype.label }}"
                                                        type="text"
                                                        [disabled]="wait"
                                                        [(ngModel)]="data.deviceType" />
                                                </lh-form-field>
                                                <lh-validation-messages
                                                    [formElement]="contactForm.form.get('deviceType')"
                                                    [formElementRef]="deviceType"
                                                    [messages]="content.form['deviceType']?.validation"></lh-validation-messages>
                                            </div>
                                        }
                                        @if (isShown) {
                                            <div class="form-element">
                                                @if (!usePortalDobComponent) {
                                                    <vn-date
                                                        #dateofbirth
                                                        name="dateofbirth"
                                                        [lhOlderThan]="118"
                                                        [lhYoungerThan]="18"
                                                        [(ngModel)]="data.birthData"></vn-date>
                                                }
                                                @if (usePortalDobComponent) {
                                                    <pt-date
                                                        #dateofbirth
                                                        name="dateofbirth"
                                                        [lhOlderThan]="118"
                                                        [lhYoungerThan]="18"
                                                        [newLayout]="true"
                                                        [(ngModel)]="data.birthData"></pt-date>
                                                }
                                                <lh-validation-messages
                                                    [formElement]="contactForm.form.get('dateofbirth')"
                                                    [formElementRef]="dateofbirth"
                                                    [messages]="content.form['dateofbirth']?.validation"></lh-validation-messages>
                                            </div>
                                        }
                                        <!--Message -->
                                        <div class="form-element">
                                            <lh-form-field [labelText]="content.form.message.label">
                                                <textarea
                                                    #message
                                                    maxlength="1000"
                                                    minlength="5"
                                                    name="message"
                                                    required
                                                    [disabled]="wait"
                                                    [(ngModel)]="data.message"></textarea>
                                            </lh-form-field>
                                            <lh-validation-messages
                                                [formElement]="contactForm.form.get('message')"
                                                [formElementRef]="message"
                                                [messages]="content.form['message']?.validation"></lh-validation-messages>
                                        </div>
                                    </section>
                                </fieldset>
                            </div>
                            @if (faqItems) {
                                <div class="layout-column">
                                    <fieldset class="faq-container">
                                        <legend [innerHtml]="content.messages!.FAQs"></legend>
                                        @for (faqItem of faqItems; track faqItem.question) {
                                            <div class="faq-item">
                                                <div class="faq-header" (click)="openFaqItem(faqItem, $event)">
                                                    <i class="theme-question"></i>
                                                    <div>{{ faqItem.question }}</div>
                                                    <i
                                                        [ngClass]="{
                                                            'theme-up': faqItem === currentFaqItem,
                                                            'theme-down': faqItem !== currentFaqItem,
                                                        }"></i>
                                                </div>
                                                @if (faqItem === currentFaqItem) {
                                                    <div class="faq-content" [innerHtml]="faqItem.content | trustAsHtml"></div>
                                                }
                                            </div>
                                        }
                                        <ul class="vertical-list">
                                            <li>
                                                <a (click)="forceContactForm()"
                                                    >{{ content.messages!.SendRequestLink }}
                                                    <i class="theme-right"></i>
                                                </a>
                                            </li>
                                            @for (link of faqPageLinks; track link.linkItems.linkText) {
                                                <li>
                                                    <a [href]="link.linkItems.url"
                                                        >{{ link.linkItems.linkText }}
                                                        <i class="theme-right"></i>
                                                    </a>
                                                </li>
                                            }
                                        </ul>
                                    </fieldset>
                                </div>
                            }
                        </div>
                        <!--Send Button -->
                        <div class="pt-4">
                            <div class="btn-area px-0" [hidden]="faqItems">
                                <div class="form-element">
                                    <button
                                        class="btn btn-primary w-100"
                                        type="button"
                                        [disabled]="wait || !contactForm.form.valid"
                                        (click)="contact()">
                                        {{ commonMessages['Send'] }}
                                    </button>
                                </div>
                            </div>
                            <div>
                                <div class="py-3" [innerHtml]="content.messages!.FAQsText | trustAsHtml"></div>
                                <div class="px-0">
                                    <a class="btn btn-outline-info w-100" target="_blank" [href]="faqLink?.linkItems.url">{{
                                        faqLink?.linkItems.linkText
                                    }}</a>
                                </div>
                            </div>
                            @if (isUserAuthenticated()) {
                                <div>
                                    <div class="py-3" [innerHtml]="content.messages!.DocUploadText | trustAsHtml"></div>
                                    <div class="px-0">
                                        <a class="btn btn-outline-info w-100" [href]="docUploadLink?.linkItems.url">{{
                                            docUploadLink?.linkItems.linkText
                                        }}</a>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div id="ctaButtonContainer" [hidden]="contactPageVisible">
                        <div class="btn-area d-flex justify-content-center">
                            <button class="btn btn-primary w-100" type="button" (click)="gotoHome()">{{ commonMessages['Continue'] }}</button>
                        </div>
                    </div>
                    @if (contactInfoText) {
                        <div class="d-flex flex-column p-3 border-top mt-5" [innerHtml]="contactInfoText | trustAsHtml"></div>
                    }
                    @if (contactInfoTextCountries) {
                        <div>
                            <h2><i class="theme-contact mr-2"></i> {{ contactInfoTextCountries.title }}</h2>
                            <div [innerHtml]="contactInfoTextCountries.text | trustAsHtml"></div>
                            <div class="form-group">
                                <div class="form-control-container form-control-dropdown">
                                    <lh-form-field>
                                        <select class="form-control form-control-select w-100" name="contactText" [(ngModel)]="geoCountry">
                                            <option disabled hidden value=""></option>
                                            @for (country of countriesList; track country.code) {
                                                <option [ngValue]="country.code">
                                                    {{ country.name }}
                                                </option>
                                            }
                                        </select>
                                    </lh-form-field>
                                </div>
                            </div>
                            @if (contactInfoTextCountries.children[geoCountry]) {
                                <div
                                    class="text-primary border border-primary rounded d-inline-block p-2 px-4 mb-2 font-weight-bold"
                                    [innerHtml]="contactInfoTextCountries.children[geoCountry].text | trustAsHtml"></div>
                            }
                            <div class="txt-s mt-4" [innerHtml]="contactInfoTextCountries.messages.Bottom | trustAsHtml"></div>
                        </div>
                    }
                </form>
                @if (zendeskChatEnabled && !removeLiveChat) {
                    <div class="form-element spacer-b">
                        <pt-pull-chat-button></pt-pull-chat-button>
                    </div>
                }
                @if (showchathistory && !optionsScreen) {
                    <div class="portal-center-wrapper content-width chatcard my-5" id="chathistory" (click)="goToHistory()">
                        <div class="chathistorycard">
                            <div class="cursorPointer d-flex align-vertically">
                                <div class="{{ initData.chatHistoryContent.messages.class }} chatoption mr-3 ml-4"></div>
                                <div class="chatbonuscard option-font align-left m-2">
                                    <div class="align-text-in-mobile m-2">
                                        <div class="heading">{{ initData.chatHistoryContent.title }}</div>
                                        <div class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0">
                                            <p>{{ initData.chatHistoryContent.messages.ChatHistory }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
        @if (initData.enableHelpAndContactPage && !initData.isVipUser) {
            <div id="contact">
                <vn-message-panel></vn-message-panel>
                <form #contactForm="ngForm" action autocomplete="off" class="helpContact" name="contactForm" novalidate>
                    @if (!optionsScreen) {
                        <div class="portal-center-wrapper" id="helpandcontactForm">
                            @if (!initData.useNewHelpAndContactTemplate) {
                                <div>
                                    <h2 class="helpcontact-contactfaq">{{ initData.helpContactContent.messages.HelpText }}</h2>
                                    <!-- Category -->
                                    @for (cl of initData.oldCategoriesList; track i; let i = $index) {
                                        <div class="form-element">
                                            <input
                                                class="custom-control-input custom-control-radio"
                                                name="contactRadio"
                                                type="radio"
                                                [checked]="cl.checked"
                                                [id]="'contactRadio' + i"
                                                (click)="selectedCategoryList(cl)" />
                                            <label class="custom-control-label" [for]="'contactRadio' + i" [innerHtml]="cl.category.title"></label>
                                        </div>
                                    }
                                    <!-- SubCategory -->
                                    <div id="Category">
                                        @if (categorySelected) {
                                            <div>
                                                <h2 class="helpcontact-contactfaq" [innerHtml]="initData.helpContactContent.messages.Faq"></h2>
                                                @for (sl of subCategoryList; track sl.title; let i = $index) {
                                                    <div class="form-element">
                                                        <input
                                                            class="custom-control-input custom-control-radio"
                                                            name="contactSubRadio"
                                                            type="radio"
                                                            [checked]="sl.checked"
                                                            [id]="'contactSubRadio' + i"
                                                            (click)="selectedSubCategoryList(sl)" />
                                                        <label
                                                            class="custom-control-label"
                                                            [for]="'contactSubRadio' + i"
                                                            [innerHtml]="sl.title"></label>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                    <!-- YesOrNo -->
                                    <div id="SubCategory">
                                        @if (selectedSubCategory) {
                                            <div>
                                                <h2 [innerHtml]="contentFaq.document.messages.Title"></h2>
                                                <div [innerHtml]="contentFaq.document.messages.Body"></div>
                                                @if (!isUserAuthenticated()) {
                                                    <div class="pc-txt" [innerHtml]="content.messages!.LoginText"></div>
                                                }
                                                <br />
                                                <p [innerHtml]="content.messages!.MoreHelpText"></p>
                                                <div id="helpcontact-buttons">
                                                    <button
                                                        class="btn de-emphasize btn-light w-50"
                                                        id="helpcontact-yesbtn"
                                                        type="button"
                                                        (click)="goToOptions()">
                                                        {{ initData.helpContactContent.messages.YesButton }}
                                                    </button>
                                                    <button
                                                        class="btn de-emphasize btn-light w-50"
                                                        id="helpcontact-nobtn"
                                                        type="button"
                                                        (click)="gotoLastKnownProduct('FAQ', 'NO')">
                                                        {{ initData.helpContactContent.messages.NoButton }}
                                                    </button>
                                                </div>
                                                <p
                                                    class="pc-txt"
                                                    [innerHtml]="contentFaq.document.messages.Footer"
                                                    (click)="faqLinkClick($event)"></p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            @if (initData.useNewHelpAndContactTemplate) {
                                <div>
                                    <h2 class="helpcontact-contactfaq">{{ initData.helpContactContent.messages.HelpText }}</h2>
                                    <!-- Category -->
                                    @for (cl of initData.newCategoriesList; track i; let i = $index) {
                                        <div class="form-element">
                                            <input
                                                class="custom-control-input custom-control-radio"
                                                name="contactRadio"
                                                type="radio"
                                                [checked]="cl.checked"
                                                [id]="'contactRadio' + i"
                                                (click)="selectedCategoryList(cl)" />
                                            <label
                                                class="custom-control-label"
                                                [for]="'contactRadio' + i"
                                                [innerHtml]="cl.category.parent.title"></label>
                                        </div>
                                    }
                                    <!-- SubCategory -->
                                    <div id="Category">
                                        @if (categorySelected) {
                                            <div>
                                                <h2 class="helpcontact-contactfaq" [innerHtml]="initData.helpContactContent.messages.Faq"></h2>
                                                @for (sl of subCategoryList; track sl.title; let i = $index) {
                                                    <div class="form-element">
                                                        <input
                                                            class="custom-control-input custom-control-radio"
                                                            name="contactSubRadio"
                                                            type="radio"
                                                            [checked]="sl.checked"
                                                            [id]="'contactSubRadio' + i"
                                                            (click)="selectedSubCategoryList(sl)" />
                                                        <label
                                                            class="custom-control-label"
                                                            [for]="'contactSubRadio' + i"
                                                            [innerHtml]="sl.title"></label>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                    <!-- YesOrNo -->
                                    <div id="SubCategory">
                                        @if (selectedSubCategory) {
                                            <div>
                                                <h2 [innerHtml]="currentSelectedSubCatergoryList.value.copyTitle"></h2>
                                                <div [innerHtml]="currentSelectedSubCatergoryList.value.copy"></div>
                                                @if (!isUserAuthenticated()) {
                                                    <div class="pc-txt" [innerHtml]="content.messages!.LoginText"></div>
                                                }
                                                <br />
                                                <p [innerHtml]="content.messages!.MoreHelpText"></p>
                                                <div id="helpcontact-buttons">
                                                    <button
                                                        class="btn de-emphasize btn-light w-50"
                                                        id="helpcontact-yesbtn"
                                                        type="button"
                                                        (click)="goToOptions()">
                                                        {{ initData.helpContactContent.messages.YesButton }}
                                                    </button>
                                                    <button
                                                        class="btn de-emphasize btn-light w-50"
                                                        id="helpcontact-nobtn"
                                                        type="button"
                                                        (click)="gotoLastKnownProduct('FAQ', 'NO')">
                                                        {{ initData.helpContactContent.messages.NoButton }}
                                                    </button>
                                                </div>
                                                <p
                                                    class="pc-txt"
                                                    [innerHtml]="currentSelectedSubCatergoryList.value.footer"
                                                    (click)="faqLinkClick($event)"></p>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </form>
                @if (showchathistory && !optionsScreen) {
                    <div class="portal-center-wrapper content-width chatcard my-5" id="chathistory" (click)="goToHistory()">
                        <div class="chathistorycard">
                            <div class="cursorPointer d-flex align-vertically">
                                <div class="{{ initData.chatHistoryContent.messages.class }} chatoption mr-3 ml-4"></div>
                                <div class="chatbonuscard option-font align-left m-2">
                                    <div class="align-text-in-mobile m-2">
                                        <div class="heading">{{ initData.chatHistoryContent.title }}</div>
                                        <div class="text-muted-secondary suboption-font bonus-card-heading-1-small contact-touch-pad-0">
                                            <p>{{ initData.chatHistoryContent.messages.ChatHistory }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
        @if ((initData.enableHelpAndContactPage && initData.isVipUser) || optionsScreen) {
            <div>
                <pt-contact-options
                    [contactData]="initData"
                    [faqLink]="faqLink"
                    [helpAndContactData]="helpAndContactData"
                    [optionsScreen]="optionsScreen"
                    [selectedCategory]="currentSelectedCategory"
                    [showEmail]="showEmail"
                    [showPhone]="showPhone"
                    (onEmailScreenLoad)="emailScreenLoad($event)"
                    (onEmailSelected)="enableEmailScreen($event)"
                    (onPhoneSelected)="enablePhoneScreen($event)"></pt-contact-options>
            </div>
        }
    </ng-template>
    @if (initData.enableHelpAndContactPhase2 && !phase3) {
        <pt-help-and-contact [content]="content" [faqLink]="faqLink" [initData]="initData" [twitterLink]="twitterLink"></pt-help-and-contact>
    }
}
